<template>
  <footer class="page-footer primary-bg">
    <div class="container">
      <div class="row">
        <div class="col l6 s12">
          <h5 class="white-text">LockerApp</h5>
          <p class="grey-text text-lighten-4">Password manager</p>
        </div>
        <div class="col l4 offset-l2 s12">
          <h5 class="white-text">Links</h5>
          <ul>
            <li>
              <router-link class="light-blue-text darken-4" to="/about">About</router-link>
            </li>
            <li>
              <router-link class="light-blue-text darken-4" to="/passwordgenerator">Password Generator</router-link>
            </li>
            <li>
              <a
                class="light-blue-text darken-4"
                target="_blank"
                href="https://play.google.com/store/apps/details?id=com.lockerapp"
              >Google Play Store</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="footer-copyright secondary-bg">
      <div class="container">
        © {{currentYear}} by,
        <a class="blue-text" target="_blank" href="https://emrebicer.github.io/">emrebicer</a>
      </div>
    </div>
  </footer>
</template>

<script>
import M from "materialize-css";

export default {
  name: "Footer",
  data: function(){
    return{
      currentYear: ''
    }
  },
  mounted() {
    this.currentYear = new Date().getFullYear()
    M.AutoInit();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
